import { useEffect } from 'react';
import type { ContractsForFinancialSecurity } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

export function useContractsForFinancialSecurity({ url }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<ContractsForFinancialSecurity>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  return request;
}

export type ContractsForFinancialSecurityRequest = ReturnType<
  typeof useContractsForFinancialSecurity
>;
